import useTranslation from 'next-translate/useTranslation';
import TimeSlot from '@atoms/TimeSlot/TimeSlot';
import type { AxfoodTimeSlotViewModel } from '@occ/api-client';
import { StyledContainer, StyledEmptyContainer } from './TimeSlots.styles';
import Text from '@atoms/Text/Text';
import { ForwardedRef, forwardRef } from 'react';

interface Props {
  slots: Array<AxfoodTimeSlotViewModel>;
  selectedSlot: AxfoodTimeSlotViewModel | null;
  onSlotClick: (slot: AxfoodTimeSlotViewModel | null) => void;
  deliveryMode?: 'homeDelivery' | 'pickUpInStore';
}

const TimeSlots = forwardRef(
  ({ slots, selectedSlot, onSlotClick, deliveryMode }: Props, ref: ForwardedRef<HTMLDivElement>) => {
    const { t } = useTranslation('timeSlots');

    return (
      <StyledContainer
        data-testid="slot-time-picker"
        deliveryMode={deliveryMode}
        selectedSlot={!!selectedSlot}
        ref={ref}
      >
        {slots?.length ? (
          slots.map((slot) => {
            const selected = selectedSlot?.code === slot.code;
            return <TimeSlot slot={slot} key={slot.code} selected={selected} onClick={onSlotClick} />;
          })
        ) : (
          <StyledEmptyContainer>
            <Text type="subhead" size="medium" color="darkGray">
              {t('noAvailableTimes')}
            </Text>
          </StyledEmptyContainer>
        )}
      </StyledContainer>
    );
  }
);
TimeSlots.displayName = 'TimeSlots';

export default TimeSlots;
